<template>
  <div>
    <v-hover v-slot:default="{ hover }">
      <v-card
        color="#363636"
        dark
        :elevation="hover ? 12 : 2"
        :class="{ 'on-hover': hover }"
        :min-height="220"
      >
        <v-card-title class="headline pb-1">{{summary.title}}</v-card-title>
        <v-divider class="ma-0 pa-0"></v-divider>
        <v-card-subtitle>
          <div class="pa-0 ma-0 body-1 white--text">
            <div class="d-flex flex-row justify-space-between">
              <div>Projected :</div>
              <div>{{summary.projected}}</div>
            </div>
          </div>
          <div class="pa-0 ma-0 body-1 white--text">
            <div class="d-flex flex-row justify-space-between">
              <div>Actual :</div>
              <div>{{summary.actual}}</div>
            </div>
          </div>
          <div class="pl-1">                            
            <div class="pa-0 ma-0" v-for="(task, index) in summary.actualTasks" :key="index">
              <div class="d-flex flex-row justify-space-between">
                <div>{{task.title}}:</div>
                <div>{{task.value}}</div>
              </div>
            </div>
          </div>
        </v-card-subtitle>
      </v-card>
    </v-hover>
  </div>
</template>
<script>
export default {
  name: 'CardSummary',
  props: [
    'summary'
  ]
}
</script>



// WEBPACK FOOTER //
// CardSummary.vue?45e07c08